var map = {
	"./products-1-m.webp": 1936,
	"./products-1.webp": 1937,
	"./products-2-m.webp": 1938,
	"./products-2.webp": 1939,
	"./products-3-m.webp": 1940,
	"./products-3.webp": 1941,
	"./products-4-m.webp": 1942,
	"./products-4.webp": 1943,
	"./products-5-m.webp": 1944,
	"./products-5.webp": 1945,
	"./products-6-m.webp": 1946,
	"./products-6.webp": 1947,
	"./products-7-m.webp": 1948,
	"./products-7.webp": 1949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1935;